import React from "react";
import { UncontrolledTooltip, Table } from 'reactstrap';

export function TablaCabecera({ paralelo }) {

  function formatter(valor) {
    return new Intl.NumberFormat('en-US', { minimumFractionDigits: '2', maximumFractionDigits: '2', signDisplay: 'never' }).format(valor)
  }
  const porcentaje = Math.round(paralelo.evaluados * 100 / paralelo.registrados);
  let i = 0;
  return (
    <Table responsive={true} striped={true}>
      <thead>
        <tr><th colSpan={4} className="text-center">Datos generales</th></tr>
      </thead>
      <tbody>
        <tr key={i++}>
          <td className="font-weight-bold">Periodo:</td>
          <td>{paralelo.anio} - {paralelo.termino}</td>
          <td className="font-weight-bold">Unidad:</td>
          <td>{paralelo.unidad}</td>
        </tr>
        {paralelo.programa != null &&
          <tr key={i++}>
            <td className="font-weight-bold">Programa:</td>
            <td>{paralelo.programa}</td>
            <td className="font-weight-bold">Cohorte:</td>
            <td>{paralelo.cohorte}</td>
          </tr>
        }
        <tr key={i++}>
          <td className="font-weight-bold">Curso:</td>
          <td>{paralelo.codigo} {paralelo.materia} P. {paralelo.paralelo}</td>
          <td className="font-weight-bold">% Respuestas:</td>
          <td>
            <span id={"tt_" + paralelo.idparalelo} >{porcentaje}%</span>
            <UncontrolledTooltip placement="left" target={"tt_" + paralelo.idparalelo}>
              {paralelo.evaluados}/{paralelo.registrados}
            </UncontrolledTooltip >
          </td>
        </tr>
        <tr key={i++}>
          <td className="font-weight-bold">Docente:</td>
          <td>{paralelo.apellidos} {paralelo.nombres}</td>
          <td className="font-weight-bold">Promedio paralelo:</td>
          <td>{formatter(paralelo.promedio)}</td>
        </tr>
      </tbody>
    </Table>
  );

}